export const materialKeys = {
  all: () => ['material'],
  list: () => ['material', 'list'],
};
